import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  planId: string;
  id: string;
  data: any
}

const mutateUpdateTask = async ({
  projectId,
  planId,
  id,
  data,
}: mutateProps) => {
  return await axiosAuth.put(`${PROJECT_API}/${projectId}/plans/${planId}/tasks/${id}`, data);
};

const useUpdateTaskMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateTask,
    ...queryParams,
  });

export default useUpdateTaskMutation;
